module.exports = __webpack_public_path__ + "static/media/ic-play.369cba18.svg";